import { render } from "./InstallBanner.vue?vue&type=template&id=2ddee4d8&scoped=true"
import script from "./InstallBanner.vue?vue&type=script&lang=js"
export * from "./InstallBanner.vue?vue&type=script&lang=js"

import "./InstallBanner.vue?vue&type=style&index=0&id=2ddee4d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddee4d8"]])

export default __exports__